import CryptoJS from "crypto-js";
import {store} from "../components/store/store.js";


// function gitLearningTools(UrunId) {
//     GIT_HEXA(UrunId);
// }

async function gitLearningTools(UrunId, SecretKey, OgrenciLink, OgretmenLink) {
    const KullaniciDetaylari = await store.state.users.KullaniciDetaylari;

    let Siniflar =[]
    const Filter = KullaniciDetaylari.organization.filter((x) => x.type === "grade")
    for (let key in Filter){
        const Sinif = {grade: parseInt(Filter[key].name.split('-')[0]), branch: Filter[key].name}
        Siniflar.push(Sinif)
    }

    let url, cokluSinif, sadeceSube
    url = KullaniciDetaylari.role_type == 'student' ? OgrenciLink : OgretmenLink

    //2-KW, 3-4-HEXAGONIA, 6-MYEDUCLASS, 8-NOM, 9-RAZ PLUS, 16-MANENO
    if (UrunId == 2 || UrunId == 3 || UrunId == 4 || UrunId == 6 || UrunId == 8 || UrunId == 9 || UrunId == 16) {
        sadeceSube = true
    } 
        //1-HLL, 10-RLP, 11-EFS+ ACEDEME JR, 13-ESPRESSO, 14-EFS+ ACADEME PLUS, 15-SENSATION
    if (UrunId == 1 || UrunId == 10 || UrunId == 11 || UrunId == 13 || UrunId == 14 || UrunId == 15){ 
        cokluSinif = true
    }
    
    //5-EPB, 7-MYEDUASSESSMENT, 12-DEUSTSCHBESTEN, 20-EXAM MANAGEMENT
    if (UrunId == 5 || UrunId == 7 || UrunId == 12 || UrunId == 20) {
        const Query = `?username=${btoa(KullaniciDetaylari.KullaniciAdi)}&password=${btoa(KullaniciDetaylari.Sifre)}`;
        window.open(url + Query);
        return
    }    		
    
    var studentData = {
        school_id:  KullaniciDetaylari.organization.find(x => x.type === 'main').id,		// Değiştirmeyiniz
        campus_id: KullaniciDetaylari.organization.find(x => x.type === 'campus').id, 		// Int, Kampüs ID, MEB Okul ID olabilir
        campus_name: KullaniciDetaylari.organization.find(x => x.type === 'campus').name,   // String olmalı
        first_name: KullaniciDetaylari.first_name,              							// String olmalı
        last_name: KullaniciDetaylari.last_name,            								// String olmalı
        username: KullaniciDetaylari.email,           										// String olmalı
        roleType: KullaniciDetaylari.role_type,  
        password: KullaniciDetaylari.Sifre,        													// Değiştirmeyiniz.
        class: cokluSinif == true ? Siniflar : store.getters.getSinifSeviye,                     	// Seviye => int olmalı
        branch: sadeceSube == true ? store.getters.getSinifSube.split('-')[1] : store.getters.getSinifSube,                    										// Şube => String olmalı
    }
    var textJson = JSON.stringify(studentData);
    var uriText = decodeURIComponent(textJson)
    var ciphertext = CryptoJS.AES.encrypt(uriText, SecretKey).toString();
    
    if(KullaniciDetaylari.role_type == 'teacher' && (UrunId == 10 || UrunId == 9 || UrunId == 17)){ //
        window.open(url);
    } else{
        url = url + btoa(ciphertext); 
        window.open(url);
    }
}

// async function gitLearningTools(UrunId) {
//     const KullaniciDetaylari = await store.state.users.KullaniciDetaylari;

//     let Siniflar =[]
//     const Filter = KullaniciDetaylari.organization.filter((x) => x.type === "grade")
//     for (let key in Filter){
//         const Sinif = {grade: parseInt(Filter[key].name.split('-')[0]), branch: Filter[key].name}
//         Siniflar.push(Sinif)
//     }

//     let url, cokluSinif, sadeceSube
//     let	secretKey = "HJx7t2KxTCHYvtzB4w7AQhVRaf7bTm9WWFQpBMiR@j7Gpgw8";
//     //HLL
//     if (UrunId == 1) {
//         url ="https://www.hlllogin.com/#/sso/?q=" 
//         cokluSinif = true
//     }

//     //KW
//     if (UrunId == 2) {
//         url = KullaniciDetaylari.role_type == 'student' ? "https://www.kidzwonder.com/#/login?sso=" : "https://www.uesportals.com/#/login/signin?sso="
//         sadeceSube = true
//     } 
    
//     //HEXAGONIA
//     if (UrunId == 3 || UrunId == 4)	{
//         url = KullaniciDetaylari.role_type == 'student' ? "https://www.hexagonia.com.tr/?sso=" : "https://www.uesportals.com/#/login/signin?sso="
//         sadeceSube = true
//     }		
    
//     //EPB
//     if (UrunId == 5) {
//         const epbQuery = `?username=${btoa(KullaniciDetaylari.KullaniciAdi)}&password=${btoa(KullaniciDetaylari.Sifre)}`;
//         url ="https://englishplaybox.net/#/" 
//         window.open(url+epbQuery);
//     }
    
//     //MYEDUCLASS		
//     if (UrunId == 6) {
//         url ="https://lms.myeduclass.com/#/?sso=" 
//         sadeceSube = true
//     }			
    
//     //MYEDUASSESSMENT
//     if (UrunId == 7){ 
//         const myEduAssessmentQuery = `?username=${btoa(KullaniciDetaylari.KullaniciAdi)}&password=${btoa(KullaniciDetaylari.Sifre)}`;
//         url = KullaniciDetaylari.role_type == 'student' ? "https://www.myeduassessment.com/#/login" : "https://report.myeduassessment.com/#/login"
//         window.open(url+myEduAssessmentQuery);
//         return				
//     }

//     //NOM
//     if (UrunId == 8){ 
//         secretKey = "Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy";
//         url ="https://service.ueslms.com/#/nom/?sso="
//         sadeceSube = true
//     }

//     //RAZ PLUS
//     if (UrunId == 9){ 
//         secretKey = "DZYQSbQQKmruR4ZYOLD%s7163BZjoyViqF7gWy.A6Gd9JAyXCL!eNGsrEJVcPUe";
//         url ="https://service.ueslms.com/#/raz-plus/?sso=" 
//         sadeceSube = true
//     }

//     //RLP
//     if (UrunId == 10){ 
//         secretKey = "VswFYGzh2k45N7Q8R9@TBuCVexFY.G2J3K4N6p7Q%9SATB-VdWeXFZHJ3m5N";
//         url ="https://service.ueslms.com/#/rlp/?sso=" 
//         cokluSinif = true
//     }

//     //EFS+ ACEDEME JR
//     if (UrunId == 11) { 
//         secretKey = "Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy";
//         url ="https://service.ueslms.com/#/efs/?sso=" 
//         cokluSinif = true
//     }

//     //DEUSTSCHBESTEN
//     if (UrunId == 12) {
//         const deuQuery = `?username=${btoa(KullaniciDetaylari.KullaniciAdi)}&password=${btoa(KullaniciDetaylari.Sifre)}`;
//         url ="https://www.deutschbesten.com/#/" 
//         window.open(url+deuQuery);
//     }

//     //ESPRESSO
//     if (UrunId == 13) { 
//         secretKey = "Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy";
//         url ="https://service.ueslms.com/#/espresso/?sso=" 
//         cokluSinif = true
//     }

//     //EFS+ ACADEME PLUS
//     if (UrunId == 14) { 
//         secretKey = "Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy";
//         url ="https://service.ueslms.com/#/efs/?sso=" 
//         cokluSinif = true
//     }

//     //SENSATION
//     if (UrunId == 15) { 
//         secretKey = "Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy";
//         url ="https://service.ueslms.com/#/sensations/?sso=" 
//         cokluSinif = true
//     }

//     //MANENO
//     if (UrunId == 16) { 
//         secretKey = "Pbt6DND9k5tu7Tdj284-1szLNPEXwcVznFMN4G@UdQtZ7.GEU7!BPy";
//         url ="https://service.ueslms.com/#/maneno/?sso=" 
//         sadeceSube = true
//     }


//     var studentData = {
//         school_id:  KullaniciDetaylari.organization.find(x => x.type === 'main').id,		// Değiştirmeyiniz
//         campus_id: KullaniciDetaylari.organization.find(x => x.type === 'campus').id, 		// Int, Kampüs ID, MEB Okul ID olabilir
//         campus_name: KullaniciDetaylari.organization.find(x => x.type === 'campus').name,   // String olmalı
//         first_name: KullaniciDetaylari.first_name,              							// String olmalı
//         last_name: KullaniciDetaylari.last_name,            								// String olmalı
//         username: KullaniciDetaylari.email,           										// String olmalı
//         roleType: KullaniciDetaylari.role_type,          													// Değiştirmeyiniz.
//         class: cokluSinif == true ? Siniflar : store.getters.getSinifSeviye,                     	// Seviye => int olmalı
//         branch: sadeceSube == true ? store.getters.getSinifSube.split('-')[1] : store.getters.getSinifSube,                    										// Şube => String olmalı
//     }
//     var textJson = JSON.stringify(studentData);
//     var uriText = decodeURIComponent(textJson)
//     var ciphertext = CryptoJS.AES.encrypt(uriText, secretKey).toString();
//     url = url + btoa(ciphertext);
//     window.open(url);
// }

export {
    gitLearningTools
};